export const LoadingList = () => {
  return (
    <div className="pt-8 lg:pt-6">
      <div className="h-[6.25rem] w-full animate-pulse bg-grey-300 shadow-[0_1px_0_0] shadow-grey-300 lg:h-[5.625rem]" />
      <div className="h-[6.25rem] w-full animate-pulse bg-grey-200 shadow-[0_1px_0_0] shadow-grey-300 lg:h-[5.625rem]" />
      <div className="h-[6.25rem] w-full animate-pulse bg-grey-300 shadow-[0_1px_0_0] shadow-grey-300 lg:h-[5.625rem]" />
      <div className="h-[6.25rem] w-full animate-pulse bg-grey-200 shadow-[0_1px_0_0] shadow-grey-300 lg:h-[5.625rem]" />
      <div className="h-[6.25rem] w-full animate-pulse bg-grey-300 shadow-[0_1px_0_0] shadow-grey-300 lg:h-[5.625rem]" />
    </div>
  );
};
